export const DONATION_HOME_PATH = '/donation';
export const DONATION_DETAIL_PATH = '/donation/detail';

/** 业务状态：展示=存储，与机构端 / corp_donation_manager 对齐 */
export const DONATION_STATUS = {
  CONTACT_PENDING: 1,
  CONTACT_REJECTED: 2,
  PENDING_PAY: 3,
  VOUCHER_REVIEW: 4,
  VOUCHER_REJECTED: 5,
  EXECUTING: 6,
};

export const DONATION_STATUS_OPTIONS = [
  { label: '善款待拨付', value: 3 },
  { label: '捐款凭证审核中', value: 4 },
  { label: '执行中', value: 6 },
];

export const DONATION_STATUS_TEXT = {
  1: '捐款凭证审核中',
  2: '捐款凭证审核中',
  3: '善款待拨付',
  4: '捐款凭证审核中',
  5: '捐款凭证审核中',
  6: '执行中',
};

/** warning=橙，success=绿；企业侧不展示驳回红 */
export const DONATION_STATUS_THEME = {
  1: 'warning',
  2: 'warning',
  3: 'warning',
  4: 'warning',
  5: 'warning',
  6: 'success',
};

export const CONTACT_CHANNEL = {
  PLATFORM: 1,
  OFFLINE: 2,
};

export const CONTACT_CHANNEL_OPTIONS = [
  { label: '平台推介', value: 1 },
  { label: '线下签署', value: 2 },
];

export const CONTACT_CHANNEL_TEXT = {
  1: '平台推介',
  2: '线下签署',
};

export const DONATION_FORM_TEXT = {
  1: '定向资金',
  2: '定向物资',
};

/** 与后端 consts.Todo* 对齐 */
export const TODO_TYPE = {
  NONE: 0,
  INVOICE: 1,
  PENDING_PAY: 2,
  UNUSED_FUND: 3,
};

export const TODO_QUERY = {
  invoice: TODO_TYPE.INVOICE,
  pendingPay: TODO_TYPE.PENDING_PAY,
  unusedFund: TODO_TYPE.UNUSED_FUND,
};

export const TODO_TAG_TEXT = {
  [TODO_TYPE.INVOICE]: '待开票',
  [TODO_TYPE.PENDING_PAY]: '待拨付善款',
  [TODO_TYPE.UNUSED_FUND]: '待使用公益金',
};

export const DETAIL_TAB = {
  BASIC: 'basic',
  CERT: 'cert',
  INVOICE: 'invoice',
  FUND: 'fund',
};

/** 公益金活动本期先关闭入口，完整能力在关联需求；改 true 即恢复列/待办/Tab */
export const FUND_ACTIVITY_ENABLED = true;

export const FUND_UNAVAILABLE_HINT = '待审核通过后可使用公益金发起活动';
export const DEFAULT_CAN_PAY_HINT = '请联系善款接收机构线下完成拨付';
export const EMPTY_FLOW_IMG = 'https://ssv-design.ssv.tencent.com/tencent-charity/tencent-charity-design-skill/playground/src/cases/beneficiary-detail/assets/empty-state/empty-record-charity.svg';

/* ===================== 捐赠票据（TAPD 1069994386137089288）===================== */

/**
 * 开票状态：与后端 GetDonationInvoiceRsp.invoice_state 一一对齐。
 * 【取值口径】与票据侧 f_status 对齐（1/2/7）；0 留给「未处理」（用户尚未申请）。
 *   0=未处理  1=已开票  2=开票中  7=开票失败
 *
 * ⚠️ 这是渲染分支的【唯一真源】。禁止前端用「有无 application_number」「有无
 * invoice_file_url」等字段自行推导状态 —— 后端已把降级、异步中间态等复杂情况
 * 统一收敛到 invoice_state，前端再推一遍必然与后端口径漂移。
 *
 * ⚠️ 【红线】degraded=true 时 invoice_state 恒为 2（开票中），【禁止】回落到 0
 * （未处理）—— 否则用户会看到「去开票」入口并重复申请，而重复申请会被下游
 * CAS 拒绝，表现为「点了没反应」。
 *
 * ⚠️ 【产品口径】invoice_state=7（开票失败）在前端【统一按「开票中」展示】：
 * 头部状态标签、卡片主体渲染均沿用 2 的样式，不向用户暴露失败信息，
 * 避免引导重试（业务侧暂不支持重试，需人工介入）。见下方 TEXT / THEME 映射。
 */
export const INVOICE_STATE = {
  NONE: 0, // 未处理（用户尚未申请开票）
  DONE: 1, // 已开票
  PROCESSING: 2, // 开票中
  FAILED: 7, // 开票失败（前端统一按「开票中」展示，见 INVOICE_STATE_TEXT/THEME）
};

export const INVOICE_STATE_TEXT = {
  0: '未开票',
  1: '已开票',
  2: '开票中',
  7: '开票中', // 后端失败态在前端展示为「开票中」
};

/** 复用 StatusTag 的主题体系：success=绿 warning=橙 danger=红 tips=灰 */
export const INVOICE_STATE_THEME = {
  0: 'tips',
  1: 'success',
  2: 'warning',
  7: 'warning', // 与文案「开票中」保持一致，展示为橙色标签
};

/**
 * 票据类型：与后端 invoice_type 对齐（1=电子 3=纸质，与机构中心 OrgDetail.invoice_type 对齐）。
 *
 * ⚠️ 后端在未开票（invoice_state=0）时 invoice_type 可能为 0/未回传，
 * 前端应视为「电子票据」缺省渲染（见 InvoiceCard.isElectronic）。
 */
export const INVOICE_TYPE = {
  ELECTRONIC: 1,
  PAPER: 3,
};

/** degraded=true 时追加的提示（票据服务查询失败，当前按「开票中」展示） */
export const INVOICE_DEGRADED_TIP = '票据信息加载失败，请稍后重试';
/** 未开票空态文案 */
export const INVOICE_EMPTY_TIP = '暂无开票记录';
/** 卡片接口彻底失败（网络层）时的文案 */
export const INVOICE_LOAD_ERROR_TIP = '票据信息加载失败';
/** 通用兜底错误文案（后端未返回 message 时使用） */
export const INVOICE_FALLBACK_ERROR = '操作失败，请稍后重试';
